<div [class.header-search-wrapper--expanded]="expanded" class="header-search-wrapper">
  @if (!expanded) {
    <button (click)="toggle($event)" aria-label="Suche öffnen" mat-icon-button>
      <mat-icon>search</mat-icon>
    </button>
  } @else {
    <div class="header-search-expanded">
      <mat-form-field appearance="outline" class="header-search-field dense-2" subscriptSizing="dynamic">
        <input #searchInput
               [formControl]="searchControl"
               (keyup.enter)="submit()"
               aria-label="Globale Suche"
               matInput
               placeholder="Suche...">
        <mat-icon (click)="toggle($event)" class="header-search-close" matSuffix>close</mat-icon>
      </mat-form-field>

      @if (searchControl.value?.trim()?.length > 0 && searchControl.value.trim().length < minQueryLength) {
        <div class="header-search-panel header-search-hint">
          Bitte mindestens {{ minQueryLength }} Zeichen eingeben.
        </div>
      } @else if (isLoading) {
        <div class="header-search-panel header-search-loading">
          <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
        </div>
      } @else if (groups.length > 0) {
        <div class="header-search-panel">
          @for (group of groups; track group.type) {
            <div class="header-search-group">
              <div class="header-search-group-label">{{ typeLabels[group.type].label }}</div>
              @for (result of group.results; track result.id) {
                <button (click)="select(group.type, result.id)" class="header-search-result">
                  <app-search-result-item [result]="result"></app-search-result-item>
                </button>
              }
              @if (group.totalMatches > group.results.length) {
                <button (click)="viewAllInDomain(group.type)" class="header-search-view-all">
                  alle {{ group.totalMatches }} Ergebnisse in {{ typeLabels[group.type].label }} anzeigen
                </button>
              }
            </div>
          }
        </div>
      } @else if (searchControl.value?.trim()?.length >= minQueryLength) {
        <div class="header-search-panel header-search-empty">Keine Ergebnisse gefunden.</div>
      }
    </div>
  }
</div>
